import React from "react";
import CategoryPageTemplate from "../CategoryPageTemplate";
import { categoryPageConfigs } from "../categoryPageConfigs";

export default function FlowersTemplate() {
  return <CategoryPageTemplate {...categoryPageConfigs.flowers} />;
}
